import React from 'react';
import loadable from '@loadable/component';
import type { Props } from './modal';

const Modal = loadable(() => import(/* webpackChunkName: "extra" */ './modal'));

const ModalLoader = (props: Props) => <Modal {...props} />;

export default ModalLoader;
